import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import Toggle from 'components/prism/toggle';
import Subheader from 'components/prism/subheader';
import Metric from '../metric';

export const Metrics = ({ title, period, setPeriod, data, loading }) => {
    const text = {
        week: SystemText('Welcome/Metrics/Week'),
        month: SystemText('Welcome/Metrics/Month'),
        quarter: SystemText('Welcome/Metrics/Quarter'),
    };

    const extra = (
        <Toggle value={period} onChange={setPeriod}>
            <button value="W">{text.week}</button>
            <button value="M">{text.month}</button>
            <button value="Q">{text.quarter}</button>
        </Toggle>
    );

    return (
        <div>
            <Subheader title={title} extra={extra} />
            <div className={data.length > 1 ? 'two-col' : ''}>
                {data.map(metric => {
                    return <Metric key={`metric-${metric.id}`} metric={metric} loading={loading} period={period} />;
                })}
            </div>
        </div>
    );
};

export default Metrics;
